<template>
  <ul class="uk-list uk-list-bullet">
    <slot></slot>
  </ul>
</template>

<script>
export default {
  name: 'b-ul'
}
</script>

<style scoped>
.uk-list {
  font-size: 1rem;
  font-weight: 500;
}

.uk-list-icon {
  display: inline-block;
  margin-right: 12px;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: rgba(34, 34, 34, 0.8);
}

.uk-list-bullet > * {
  padding-left: 0;
}

.uk-list-bullet > ::before {
  display: none;
  /*background-image: url("data:image/svg+xml,%3Csvg width='12' height='12' viewBox='0 0 12 12' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Ccircle cx='6' cy='6' r='6' fill='%23222222' fill-opacity='0.8'/%3E%3C/svg%3E");*/
}
</style>
